import { Store, StoreStatus } from "../../../types"
import syncz from '../../../assets/syncz.svg';
import Arrow from "../../../assets/Arrow";
import { getStatus } from "../../../lib/admin";
import { useState } from "react";
import FilterSync from "../../../assets/FilterSync";
import StoreCardSyncModal from "./StoreCardSyncModal";
import SyncAllButton from "../SyncAllButton";
import { useAppSelector } from "../../../app/hooks";
import { buildStoreSyncingSelector } from "../storesSyncSlice";


type Props =
    {
        store: Store,
        error: string | undefined,
        syncStore: () => void,
        enabled: boolean
    }

export default function StoreCardSyncArea({ store, error, syncStore, enabled }: Props) {
    const isSyncing = useAppSelector(buildStoreSyncingSelector(store.id));
    const [status, setStatus] = useState<StoreStatus | undefined>(undefined);

    const getSync = () => {
        if (!enabled) return "Disabled";
        return isSyncing ? "Synchronizing" : "Idle";
    }

    const getClassSync = () => {
        if (!enabled) return "disabled";
        return isSyncing ? "synchronizing" : "idle";
    }

    const updateStatus = async () => {
        const result = await getStatus(store.id);
        if (result != undefined)
            setStatus(result)
    }

    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const iconColor = !enabled ? "#ABBDD6" : "#fff";

    return (
        <div className="bottomArea">
            <div className="leftArea">
                <div className="two-col">
                    <p className={`title type status`}>
                        Status:
                        <span className={`status-${getClassSync()}`}>
                            {getSync()}
                        </span>
                    </p>
                </div>
                <div className="sync-button-container">
                    <div className="basic-dates-store actions-panel syncMenuBtn">
                        <button disabled={!enabled} type="button" onClick={openModal} className={!enabled ? "btn btn-primary disabled" : "btn btn-primary"}>
                            <FilterSync color={iconColor} />
                            <span>Sync</span>
                        </button>
                    </div>
                    <div className="basic-dates-store actions-panel syncBtn">
                        <SyncAllButton
                            className={isSyncing ? "div-button-synchronising" : !enabled ? "btn btn-primary disabledAll" : "btn btn-primary"}
                            label={isSyncing ? "Synchronizing" : "Sync All"}
                            syncing={isSyncing}
                            disabled={!enabled}
                            onClick={() => syncStore()}
                            iconColor={iconColor}
                        />
                    </div>
                </div>
            </div>
            {/* <div className="">
                <div className="row">
                    <div className="container-progress">
                        <p className="progress-title">{store.syncState == 1 || store.syncV2IsRunning === 1 ? 'Progress:' : ''}</p>
                        {store.syncState == 1 || store.syncV2IsRunning === 1 ?
                            <div className={"button-progress"}>
                                <button onClick={() => updateStatus()}>
                                    Refresh
                                </button>
                                {status != undefined &&
                                    <span className="data-progress">
                                        {status.progressPercent + "%"}
                                    </span>
                                }
                            </div>
                            : <></>
                        }
                    </div>

                </div>
            </div> */}
            {error !== undefined && error !== "" && (
                <div className="errorArea">
                    <div className={"store-error-section"}>
                        <p className="store-error-message">{error}</p>
                    </div>
                </div>
            )}
            <div className="modal-overlay">
                {showModal && (
                    <StoreCardSyncModal store={store} close={closeModal} syncStore={syncStore} />
                )}
            </div>
        </div>
    )

}